import Dashboard from 'services/dashboard';
import { toast } from 'react-toastify';
import {
  FETCH_DASHBOARD_SUMMARY,
  DASHBOARD_ASYNC_START,
  UPDATE_DASHBOARD_FILTERS,
  UPDATE_DASHBOARD_PAGINATION,
  FETCH_DASHBOARD_TRANSACTIONS,
  FETCH_WALLET_BALANCE,
  CHECk_ACCOUNT_STATUS,
  DASHBOARD_ASYNC_END,
  FETCH_OVERVIEW_GRAPH,
  FETCH_TRANSACTION_VOLUME,
  FETCH_TRANSACTION_AMOUNT,
  FETCH_TRANSACTIONS_FROM_SOURCE,
} from '../types';
import { showToast } from './toast';

export const fetchDashboardSummary =
  (filters) => async (dispatch, getState) => {
    dispatch({
      type: DASHBOARD_ASYNC_START,
      subType: 'summary',
    });
    try {
      const {
        common: { user },
      } = getState();
      const { data } = await Dashboard.fetchSummary({
        ...filters,
        merchantId: user?.merchantId,
      });
      dispatch({
        type: FETCH_DASHBOARD_SUMMARY,
        payload: data,
        subType: 'summary',
      });
    } catch (error) {
      return toast.error(
        error?.response?.data?.message || 'Something went wrong',
      );
    }
  };

export const fetchWalletBalance = () => async (dispatch, getState) => {
  dispatch({
    type: DASHBOARD_ASYNC_START,
    subType: 'summary',
  });
  try {
    const {
      common: { user },
    } = getState();
    const { data } = await Dashboard.walletBalance(user?.walletId);
    dispatch({
      type: FETCH_WALLET_BALANCE,
      payload: data?.amount,
    });
  } catch (error) {
    return toast.error(
      error?.response?.data?.message || 'Something went wrong',
    );
  }
};

export const fetchTransactionFromSource =
  (params) => async (dispatch, getState) => {
    dispatch({
      type: DASHBOARD_ASYNC_START,
      subType: 'transactionsFromSource',
    });
    const {
      common: { user },
    } = getState();

    const transactionsParams = {
      ...params,
      order: 'DESC',
      sortBy: 'createdAt',
    };

    try {
      const {
        data: { list, ...rest },
      } = await Dashboard.fetchTransactionBySource(
        user?.merchantId,
        transactionsParams,
      );

      dispatch({
        type: FETCH_TRANSACTIONS_FROM_SOURCE,
        payload: { list, pagination: rest },
        subType: 'transactionsFromSource',
      });
    } catch (e) {
      dispatch({
        type: DASHBOARD_ASYNC_END,
        subType: 'transactionsFromSource',
      });
      return toast.error(e?.response?.data?.message || 'Something went wrong');
    }
  };

export const fetchDashboardTransactions =
  (params) => async (dispatch, getState) => {
    dispatch({
      type: DASHBOARD_ASYNC_START,
      subType: 'transactions',
    });
    const {
      common: { user },
    } = getState();
    const transactionsParams = {
      ...params,
      order: 'DESC',
      sortBy: 'createdAt',
    };
    try {
      const {
        data: { list, ...rest },
      } = await Dashboard.fetchTransactions(
        user?.merchantId,
        transactionsParams,
      );
      dispatch({
        type: FETCH_DASHBOARD_TRANSACTIONS,
        payload: { list, pagination: rest },
        subType: 'transactions',
      });
    } catch (error) {
      dispatch({
        type: DASHBOARD_ASYNC_END,
        subType: 'transactions',
      });
      return toast.error(
        error?.response?.data?.message || 'Something went wrong',
      );
    }
  };

export const updateDashboardFilters = (filters) => async (dispatch) =>
  dispatch({
    type: UPDATE_DASHBOARD_FILTERS,
    payload: filters,
  });

export const updateDashbaoordTransactionsPagination =
  (page) => async (dispatch) =>
    dispatch({
      type: UPDATE_DASHBOARD_PAGINATION,
      payload: page,
      subType: 'transactions',
    });

export const downloadReport = (body, onSuccess, onFail) => async (dispatch) => {
  dispatch({
    type: DASHBOARD_ASYNC_START,
    subType: 'report',
  });
  try {
    const response = await Dashboard.downloadReport(body);
    if (onSuccess) {
      onSuccess();
    }
    dispatch({
      type: DASHBOARD_ASYNC_END,
      subType: 'report',
    });
    dispatch(showToast('success', response?.message));
    return toast.success(response?.message);
  } catch (error) {
    dispatch({
      type: DASHBOARD_ASYNC_END,
      subType: 'report',
    });
    if (onFail) {
      onFail();
    }
    dispatch(
      showToast(
        'error',
        error?.response?.data?.message || 'Something went wrong. Try again',
      ),
    );
  }
};

export const checkAccountStatus =
  (onSuccess = () => null) =>
  async (dispatch, getState) => {
    dispatch({
      type: DASHBOARD_ASYNC_START,
      subType: 'accountChecker',
    });
    const {
      common: { user },
    } = getState();
    try {
      const { data, message } = await Dashboard.checkAccountStatus(
        user?.merchantId,
      );
      dispatch({
        type: CHECk_ACCOUNT_STATUS,
        payload: data,
      });
      return onSuccess();
    } catch (error) {
      dispatch({
        type: DASHBOARD_ASYNC_END,
        subType: 'accountChecker',
      });
      dispatch(
        showToast(
          'error',
          error?.response?.data?.message || 'Something went wrong. Try again',
        ),
      );
    }
  };

export const fetchOverviewGraph = (params) => async (dispatch, getState) => {
  dispatch({
    type: DASHBOARD_ASYNC_START,
    subType: 'graph',
  });

  try {
    const { data } = await Dashboard.fetchOverviewGraph(params);
    dispatch({
      type: FETCH_OVERVIEW_GRAPH,
      payload: data.horizontalAxis,
    });
    return toast.success('success');
  } catch (error) {
    dispatch({
      type: DASHBOARD_ASYNC_END,
      subType: 'graph',
    });
    dispatch(
      showToast(
        'error',
        error?.response?.data?.message || 'Something went wrong. Try again',
      ),
    );
  }
};

export const fetchTransactionAmount =
  (params) => async (dispatch, getState) => {
    dispatch({
      type: DASHBOARD_ASYNC_START,
      subType: 'transactionAmount',
    });

    try {
      const { data } = await Dashboard.fetchTransactionAmount(params);
      dispatch({
        type: FETCH_TRANSACTION_AMOUNT,
        payload: data,
      });
      return toast.success('success');
    } catch (error) {
      dispatch({
        type: DASHBOARD_ASYNC_END,
        subType: 'transactionAmount',
      });
      dispatch(
        showToast(
          'error',
          error?.response?.data?.message || 'Something went wrong. Try again',
        ),
      );
    }
  };

export const fetchTransactionVolume =
  (params) => async (dispatch, getState) => {
    dispatch({
      type: DASHBOARD_ASYNC_START,
      subType: 'transactionVolume',
    });

    try {
      const { data } = await Dashboard.fetchTransactionVolume(params);
      dispatch({
        type: FETCH_TRANSACTION_VOLUME,
        payload: data,
      });
      return toast.success('success');
    } catch (error) {
      dispatch({
        type: DASHBOARD_ASYNC_END,
        subType: 'transactionVolume',
      });
      dispatch(
        showToast(
          'error',
          error?.response?.data?.message || 'Something went wrong. Try again',
        ),
      );
    }
  };
